import React, { useState } from 'react';
import { getVerticalOffsetForOverlay } from './getVerticalOffset';
import AnchoredModal from '@components/Shared/Modal/AnchoredModal/AnchoredModal';
import homeDetailsSVGs from '../../FindAHomeDetails/Features/FeatureTagSVGData';
import Checkmark from './Checkmark';
import Colors from 'pubweb-smokey/dist/colors';
import { allAvailableFeatures } from '@utils/homeSearchConstants';

type Props = {
  selectedFeatures: string[];
  onCloseClick: () => void;
  onApplyClick: (newSelectedFeatures: string[]) => void;
};

const FilterFeatures = ({
  onCloseClick,
  selectedFeatures,
  onApplyClick,
}: Props) => {
  const [filterFeatures, setFilterFeatures] = useState(selectedFeatures);

  const setFilter = (feature: string) => {
    if (filterFeatures.includes(feature)) {
      setFilterFeatures(filterFeatures.filter((x) => x !== feature).sort());
    } else {
      setFilterFeatures([...filterFeatures, feature].sort());
    }
  };

  const focusMove = (value: number) => {
    const current = document.activeElement as HTMLElement;
    const items = Array.from(document.getElementsByClassName('feature-item'));

    if (items.length > 0) {
      const currentIndex = items.indexOf(current);
      let newIndex = currentIndex + value;

      if (newIndex < 0) {
        newIndex = 0;
      }

      if (newIndex > items.length - 1) {
        newIndex = items.length - 1;
      }

      (items[newIndex] as HTMLElement).focus();
    }
  };

  return (
    <AnchoredModal
      automationId="filters-features"
      applyButtonClassName="filters-features-apply-button"
      clearButtonClassName="filters-clear-button"
      onApplyButtonClick={() => {
        if (
          [...filterFeatures].sort().join(',') ===
          [...selectedFeatures].sort().join(',')
        ) {
          onCloseClick();
        } else {
          onApplyClick(filterFeatures);
        }
      }}
      onClearButtonClick={() => {
        if (filterFeatures.length > 0) {
          onApplyClick([]);
        } else {
          onCloseClick();
        }
      }}
      onCloseClick={onCloseClick}
      pageOverlayVerticalOffsetInPixels={getVerticalOffsetForOverlay()}
    >
      <div>
        <ul>
          {allAvailableFeatures.map((feature) => {
            const result = homeDetailsSVGs.find(
              (svg) => svg.tagName === feature
            );
            const isSelected = filterFeatures.includes(feature);

            if (!result) {
              return <></>;
            }

            return (
              <li
                tabIndex={0}
                key={feature}
                className="feature-item flex cursor-pointer items-center"
                onClick={() => setFilter(feature)}
                onKeyDown={(ev) => {
                  ev.stopPropagation();
                  if (ev.key === 'Enter') {
                    setFilter(feature);
                  } else if (ev.key === 'ArrowUp') {
                    focusMove(-1);
                  } else if (ev.key === 'ArrowDown') {
                    focusMove(1);
                  }
                }}
              >
                <p className="pl-0.5">{React.createElement(result.icon)}</p>
                <p className="w-2/3 pl-3">{result.tagName}</p>
                {isSelected && (
                  <div className="pr-4">
                    <Checkmark
                      className="w-3.5"
                      color={Colors.primary.claytonBlue.standard}
                    />
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </AnchoredModal>
  );
};

export default FilterFeatures;
